<template>
  <div class="default-sidebar">
    <div class="sidebar-item" v-for="(tabsItem, tabsIndex) in tabsList" :key="tabsItem.name">
      <tabs type="subAccount" :tabsName="tabsItem.name" :tabsIndex="tabsIndex" :tabsComponent="tabsItem.component" :url="tabsItem.url" :isOpen="tabsItem.open" :subTabsList="tabsItem.subTabs" />
    </div>
  </div>
</template>

<script>
import tabs from './components/tabs.vue'
export default {
  name: 'SubAccountSidebar',
  data() {
    return {
      tabsList: [
        {
          name: '子账号管理',
          url: '/subAccount',
          border: true,
          open: false
          // component: 'SubAccountManagement'
        }
      ]
    }
  },
  components: {
    tabs
  }
}
</script>

<style lang="scss" scoped>
.default-sidebar {
  min-width: 225px;
  border-top: solid 2px #ebebeb;
  .sidebar-item {
    background-color: #fafafa;
    cursor: pointer;
  }
}
</style>
